import { render } from "./orderHistory.vue?vue&type=template&id=08d311a5&scoped=true"
import script from "./orderHistory.vue?vue&type=script&lang=js"
export * from "./orderHistory.vue?vue&type=script&lang=js"

import "./orderHistory.vue?vue&type=style&index=0&id=08d311a5&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08d311a5"]])

export default __exports__